(ns ycweb.app.website.dlp.widgets.testimonial
  (:require
   [rum.core :as rum]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]))

(rum/defc testimonial < rum/reactive [_ _ {:keys [properties]}]
  (let [{:testimonial/keys
         [testimonial author rating button-text button-url]}
        properties]
    (when testimonial
      [:div.yc-section
       (when (> rating 0)
         [:div.pinned-review__stars
          [:div
           {:class (u/bem :star-rating [(keyword (str rating))])}]])
       [:aside.pinned-review
        [:p.pinned-review__quote
         {:dangerouslySetInnerHTML
          {:__html testimonial}}]
        [:small.pinned-review__author author]]
       (when
         (and
           (u/presence button-text)
           (u/presence button-url))
         [:div.button-group
          {:class (u/bem :button-wrapper [:align-center])}
          (buttons/button-web button-text
            {:style :primary
             :size :default
             :href button-url})])])))
